<template>
  <div>
    <div v-if="getPostsLinkedin && getPostsLinkedin.length > 0">
      <PaginationPage  :total="getTotalLinkedin"
                       :currentPage.sync="currentPage"
                       :pageSize.sync="pageSize"
                       @update:currentPage="fetchPage"
                       @update:pageSize="fetchPageSize"/>
    </div>
    <div class="cards-wrapper" v-loading="getLoadingLinkedin" :element-loading-text="$t('portals.list.chargementDonnees')">
      <div v-for="post in getPostsLinkedin" :key="post.id">
        <div class="card">
          <div class="card-header">
            <div v-if="post.video === '' || post.image === ''" class="bg-app-photo">
              <img :src="require('@/assets/APP_PHOTO.png')" alt="Appareil photo image"/>
            </div>
            <div v-if="!post.video && !post.image" class="bg-app-photo">
              <img :src="require('@/assets/APP_PHOTO.png')" alt="Appareil photo image"/>
            </div>
            <div v-if="post.video !== ''">
              <video autoplay muted loop class="card-video">
                <source :src="post.video" type="video/mp4">
              </video>
            </div>
            <span v-if="!post.video && post.image !== ''">
              <img  v-if="!isUserDemo" :src="post.image" alt="Card Image" />
              <img  v-else :src="getImageUrl(post.image)" alt="Card Image"  class="card-image"/>
            </span>
          </div>
          <div class="card-body">
            <div class="card-left">
              <p><span class="subtitle">{{ $t("statisticsMeta.publishedOn") }} : </span>{{ moment(post.publishedAt).format('DD/MM/YYYY') }}</p>
              <p>{{ $t("statisticsMeta.likeNumber") }} : <span class="highlight">{{ post.totalLikes}}</span></p>
              <p>{{ $t("statisticsMeta.comments") }} : <span class="highlight">{{ post.totalComments }}</span></p>
            </div>
            <div class="card-right">
              <span class="subtitle">{{ $t("statisticsMeta.description") }} : </span>
              <p>{{ truncatedText(post.commentary) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="getPostsLinkedin && getPostsLinkedin.length > 0">
      <PaginationPage  :total="getTotalLinkedin"
                       :currentPage.sync="currentPage"
                       :pageSize.sync="pageSize"
                       @update:currentPage="fetchPage"
                       @update:pageSize="fetchPageSize"/>
    </div>
  </div>
</template>
<script>
import PaginationPage from '@/components/ui/PaginationPage.vue'
import moment from 'moment/moment'
import { mapGetters } from 'vuex'

export default {
  name: 'PublicationCardLinkedin',
  components: { PaginationPage },
  data () {
    return {
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    ...mapGetters(['isUserDemo', 'getSitimmoUser']),
    moment () {
      return moment
    },
    getLoadingLinkedin () {
      return this.$store.getters['statisticsLinkedin/getLoadingLinkedin']
    },
    getPostsLinkedin () {
      return this.$store.getters['statisticsLinkedin/getPostsLinkedin'].elements
    },
    getTotalLinkedin () {
      return this.$store.getters['statisticsLinkedin/getTotal']
    }
  },
  methods: {
    truncatedText (text) {
      const newText = text && text.length > 200
        ? text.substring(0, 200) + '...'
        : text
      // Pour supprimer les @[...](...) dans les commentaires
      return newText.replace(/@\[[^\]]+\]\([^\)]+\)/g, '')
    },
    fetchPage (page) {
      const startIndex = (this.currentPage - 1) * this.pageSize
      this.currentPage = page
      this.$store.commit('statisticsLinkedin/setFilters', { key: 'start', value: startIndex })
      this.$store.dispatch('statisticsLinkedin/loadStatisticsLinkedin')
    },
    fetchPageSize (size) {
      this.$store.commit('statisticsLinkedin/setFilters', { key: 'count', value: size })
      this.pageSize = size
      this.currentPage = 1
      this.$store.commit('statisticsLinkedin/setFilters', { key: 'start', value: 0 })
      this.$store.dispatch('statisticsLinkedin/loadStatisticsLinkedin')
    },
    getImageUrl (imageName) {
      return require(`@/assets/fakePictures/${this.getSitimmoUser.login}/${imageName}`)
    }
  }
}

</script>
<style scoped>
.cards-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.card {
  width: 450px;
  height: 400px;
  border: 1px solid #ccc;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.card-header {
  width: 100%;
  height: 200px;
  display: flex;
  background: #FFEFDF;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.card-header img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  position: absolute;
}

.card-image {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0%);
}

.card-body {
  max-height: 400px;
  padding: 15px;
  flex-grow: 1;
  display: flex;
  justify-content: space-around;
}

.card-left {
  min-width: 50%;
}

.card-right {
  min-width: 50%;
  margin-left: 10px;
}

.card-left p,
.card-right p {
  min-width: 50%;
  margin: 5px 0;
  color: #000;
}

.card-video {
  width: 100%;
  height: auto;
  max-width: 300px;
  max-height: 180px;
  border: none;
}
.highlight {
  color: #00a4bd;
  font-weight: 700;
}

.subtitle{
  color: #184a56;
  line-height: 1.5;
  font-weight: 700;
}

.bg-app-photo {
  background: #FFEFDF;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
}

.bg-app-photo img {
  width: 200px;
  height: auto;
}
</style>
